import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';

const CallbackPage = () => {
  const navigate = useNavigate();
  const { checkAuthStatus, user, isUserProfileIncomplete } = useAuth();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        await checkAuthStatus();
        // After checkAuthStatus, the 'user' object in context will be updated.
        // We need to wait for the next render cycle or use the updated user from AuthProvider.
        // For immediate check, we can rely on the user object being updated by checkAuthStatus
        // and then checking its completeness.
        // However, user will be null until AuthProvider's useEffect updates it.
        // A better approach is to rely on checkAuthStatus to implicitly update the user state.
        // Let's re-fetch the user after checkAuthStatus to ensure we have the latest state.

        // One way is to have checkAuthStatus return the user, but it doesn't.
        // So, we'll wait for the user state to update and then check.
        // This useEffect will run when `user` changes.
      } catch (error) {
        console.error('Callback error:', error);
        navigate('/login', { replace: true });
      }
    };

    handleCallback();
  }, [navigate, checkAuthStatus]);

  useEffect(() => {
    if (user && !isUserProfileIncomplete(user)) {
      navigate('/module/1', { replace: true }); //later, need to update to redirect to last visited page
      //  navigate('/home', { replace: true }); // Redirect to home page if profile is complete
    } else if (user && isUserProfileIncomplete(user)) {
      navigate('/profile', { replace: true });
    }
    // No action if user is null or loading
  }, [user, isUserProfileIncomplete, navigate]);

  return (
    <div className="app-container">
      <div className="splash-screen">
        <div className="loading-spinner"></div>
        <p>Signing you in...</p>
      </div>
    </div>
  );
};

export default CallbackPage;